export const phoneMask = (value: string) => {
  const parsedValue = value?.replace(/\D/g, '')

  if (value) {
    if (parsedValue.length > 10)
      return parsedValue
        .replace(/\D/g, '')
        .replace(/(\d{2})(\d)/, '($1) $2')
        .replace(/(\d{5})(\d)/, '$1 - $2')
        .replace(/(\d{4}$)\d+?/, '$1')
    if (parsedValue.length > 9)
      return parsedValue
        .replace(/(\d{2})(\d)/, '($1) $2')
        .replace(/(\d{4})(\d)/, '$1 - $2')
        .replace(/(\d{4})\d+?/, '$1')
    return parsedValue
      .replace(/(\d{4})(\d)/, '$1 - $2')
      .replace(/(\d{4})\d+?/, '$1')
  }
  return value
}
